// extracted by mini-css-extract-plugin
module.exports = {"forgot-password":"form_forgot-password__GFJKv"};